export enum InstitutionEnum {
  INSTITUTION_UNI = 'uni',
  INSTITUTION_PATHWAY = 'pathway',
  INSTITUTION_ALl = 'all',
}

export enum ActionSelection {
  RESEND_INVITE = 'RESEND_INVITE',
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESET_MFA = 'RESET_MFA',
  ASSIGN_VISA_SUPPORT = 'ASSIGN_VISA_SUPPORT',
  UNASSIGN_VISA_SUPPORT = 'UNASSIGN_VISA_SUPPORT',
  SERVICES = 'SERVICES',
  REQUEST_INTERVIEW = 'REQUEST_INTERVIEW',
  CANCEL_INTERVIEW = 'CANCEL_INTERVIEW',
  IMMIGRATION_PROVIDERS = 'IMMIGRATION_PROVIDERS',
}
